(function(){
  if(window.__o3d) return; window.__o3d=true;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  },{threshold:.12}) : null;
  function init(scope){
    scope.querySelectorAll('.o3d-reveal:not(.is-in)').forEach(function(el){ io ? io.observe(el) : el.classList.add('is-in'); });
    scope.querySelectorAll('[data-o3d-slider]').forEach(function(s){
      if(s.dataset.bound) return; s.dataset.bound='1';
      var rail=s.querySelector('.o3d-slider__rail');
      s.querySelectorAll('.o3d-slider__arrows button').forEach(function(b){
        b.addEventListener('click',function(){ rail.scrollBy({left:(+b.dataset.dir)*280,behavior:'smooth'}); });
      });
      s.querySelectorAll('.o3d-vid').forEach(function(c){
        var v=c.querySelector('video'), p=c.querySelector('button.o3d-vid__play');
        if(v&&p){ p.addEventListener('click',function(){ v.controls=true; v.muted=false; v.play(); p.remove(); }); }
      });
    });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',function(){ init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
  document.addEventListener('shopify:block:select',function(e){ var el=e.target; if(el&&el.classList) el.classList.add('is-in'); });
})();
